//
//
//
//
//
//
//
//
//
//

import {base, prefix} from '../../common/mixins'

export default {
  name: 'Notify',
  mixins: [base, prefix],
  /* eslint-disable vue/require-default-prop */
  props: {
    value: Boolean,
    content: String,
    position: {
      type: String,
      default: 'top',
    },
    time: {
      type: Number,
      default: 5000,
    },
  },
  /* eslint-enable */
  data () {
    return {
      show: false,
    }
  },
  computed: {
    transition () {
      return this.position === 'bottom' ? this.b('slide-in-up') : this.b('slide-in-down')
    },
    positionClass () {
      return this.position === 'bottom' ? this.c('bottom') : this.c('top')
    },
  },
  watch: {
    value (val) {
      this.show = val
    },
    show (val) {
      // 标签用法时需要发射一个input事件，修改v-model绑定的属性值
      this.$emit('input', val)
      val &&
        setTimeout(() => {
          this.show = false
        }, this.time)
    },
  },
  created () {
    if(this.value) {
      this.show = this.value
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Dialog/Notify.vue